import { FilterTimeWindowBtn } from '../../../stations/components/SingleStation/AnalysisComp/AnalysisComp'
import ChargingSessionChart from './ChargingSessionAnalysis/ChargingSessionChart'
import SingleChargingSessionInfo from './SingleChargingSessionInfo'

export const SingleChargingSession = {
    Info: SingleChargingSessionInfo,
    Charts:{
        GenericChart: ChargingSessionChart,
        FilterTimeWindowBtn: FilterTimeWindowBtn
    }
}
